import { IconProps } from "@/types/types";

export default function Mail({ width = "24", height = "24" }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.75 13.9401L2 8.88825V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8.88824L13.25 13.9401C12.4765 14.3867 11.5235 14.3867 10.75 13.9401Z" fill="currentColor" />
            <path d="M12 11.775L2 6.00153V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V6.00152L12 11.775Z" fill="currentColor" />
        </svg>


    )
}

